/* global G */
import ui from 'lib/hook/ui/update'
import readAttribute from 'lib/hook/model/readAttribute'

const _baseHooks = {
  before: [],
  after: [
    readAttribute('sensor'),
    ui,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _baseHooks,
  },
}

export default hooks
